import { supabase } from "../lib/supabase";

/**
 * Save a booking invoice record in the database
 */
export const createBookingInvoice = async (
  bookingId: number,
  filePath: string
) => {
  try {
    console.log("Creating invoice record with:", {
      booking_id: bookingId,
      booking_invoice_file: filePath
    });
    
    // Insert new invoice record
    const { data, error } = await supabase
      .from("booking_invoice")
      .insert([
        {
          booking_id: bookingId,
          booking_invoice_file: filePath
        }
      ])
      .select();

    if (error) {
      console.error("Database error during insert:", error);
      throw error;
    }

    return {
      success: true,
      data,
      error: null
    };
  } catch (error) {
    console.error("Error creating booking invoice:", error);
    return {
      success: false,
      data: null,
      error
    };
  }
};

/**
 * Get all invoices for a booking
 */
export const getBookingInvoices = async (bookingId: number) => {
  try {
    console.log(`Fetching invoices for booking ID: ${bookingId}`);
    const { data, error } = await supabase
      .from("booking_invoice")
      .select("*")
      .eq("booking_id", bookingId)
      .order("created_at", { ascending: false });

    if (error) {
      console.error("Database error during select:", error);
      throw error;
    }

    console.log(`Found ${data?.length || 0} booking invoices`);
    return {
      success: true,
      data,
      error: null
    };
  } catch (error) {
    console.error("Error fetching booking invoices:", error);
    return {
      success: false,
      data: [],
      error
    };
  }
};

/**
 * Delete a booking invoice
 */
export const deleteBookingInvoice = async (invoiceId: number) => {
  try {
    // Get the invoice record first to get the file path
    const { data: invoice, error: fetchError } = await supabase
      .from("booking_invoice")
      .select("booking_invoice_file")
      .eq("id", invoiceId)
      .single();

    if (fetchError) {
      console.error("Database error during fetch:", fetchError);
      throw fetchError;
    }

    // Delete from database
    const { error: deleteError } = await supabase
      .from("booking_invoice")
      .delete()
      .eq("id", invoiceId);

    if (deleteError) {
      console.error("Database error during delete:", deleteError);
      throw deleteError;
    }

    // Delete file from storage if we have a file path
    if (invoice?.booking_invoice_file) {
      const { error: storageError } = await supabase.storage
        .from("bookinginvoices")
        .remove([invoice.booking_invoice_file]);

      if (storageError) {
        console.error("Error deleting invoice file from storage:", storageError);
      }
    }

    return {
      success: true,
      error: null
    };
  } catch (error) {
    console.error("Error deleting booking invoice:", error);
    return {
      success: false,
      error
    };
  }
}; 